import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AdminRoleSwitchService } from '@core/services/admin-role-switch.service';

/**
 * Attaches X-Demo-Role header to all API requests when admin role switch is active.
 */
export const demoRoleInterceptor: HttpInterceptorFn = (req, next) => {
  const roleSwitchService = inject(AdminRoleSwitchService);
  const demoRole = roleSwitchService.getDemoRoleHeader();

  if (demoRole) {
    const cloned = req.clone({
      setHeaders: { 'X-Demo-Role': demoRole },
    });
    return next(cloned);
  }

  return next(req);
};
